<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="150px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="名称：" prop="Nickname">
          <el-input
            v-model="dataForm.Nickname"
            clearable
            placeholder="请输入昵称"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="MobileNo">
          <el-input
            v-model="dataForm.MobileNo"
            clearable
            placeholder="请输入手机号码"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="Email">
          <el-input
            v-model="dataForm.Email"
            clearable
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="注册方式：" prop="AccountType">
          <el-select
            v-model="dataForm.AccountType"
            placeholder="请选择注册方式"
          >
            <el-option
              v-for="item in accountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              clearable
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="微信名称：" v-if="dataForm.AccountType == 2">
          <el-input
            v-model="dataForm.WeChatname"
            clearable
            placeholder="请输入邮箱"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="账户类型：" prop="MemberType">
          <el-select v-model="dataForm.MemberType" placeholder="请选择账户类型">
            <el-option
              v-for="item in memberType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              clearable
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户角色：" prop="RoleType">
          <el-checkbox-group
            v-model="checkedwillingness"
            :min="0"
            :max="4"
            @change="handleChecked"
          >
            <el-checkbox
              v-for="item in willingness"
              :label="item.label"
              :key="item.value"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="注册时间:" prop="CreateTime">
          <el-date-picker
            v-model="dataForm.CreateTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import md5 from "js-md5";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      if (!/^1[0-9]{10}$/.test(value)) {
        return callback(new Error("无效手机号码"));
      }
      callback();
    };
    //验证电子邮箱
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      }
      if (
        !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
          value
        )
      ) {
        return callback(new Error("无效电子邮箱"));
      }
      callback();
    };
    return {
      editFormRules: {
        Nickname: {
          required: true,
          message: "昵称不能为空",
          trigger: "blur",
        },
        MobileNo: {
          required: true,
          validator: checkMobileNo,
          trigger: "blur",
        },
        Email: {
          required: true,
          validator: checkEmail,
          trigger: "blur",
        },
        AccountType: {
          required: true,
          message: "注册方式不能为空",
          trigger: "blur",
        },
        CreateTime: {
          required: true,
          message: "注册时间不能为空",
          trigger: "blur",
        },
      },
      isConfirm: false,
      width: "40%",
      accountType: [
        { value: 1, label: "手机" },
        { value: 2, label: "微信" },
      ],
      memberType: [
        { value: 1, label: "个人" },
        { value: 2, label: "团体" },
      ],
      willingness: [
        { value: "1", label: "受赠者" },
        { value: "2", label: "捐赠者" },
        { value: "3", label: "捐献者" },
        { value: "4", label: "救护者" },
      ], //账户角色
      checkedwillingness: [], //账户角色选中数组
    };
  },
  components: {
    OfDialog,
  },
  computed: {
    AccountType() {
      return (data) => {
        return data == 1 ? "PC" : "微信";
      };
    },
  },
  mounted() {
    let that = this;
    that.getCheck();
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          if (!this.dataForm.Id) {
            this.dataForm.Password = md5("123456");
            this.dataForm.Sex = 0;
            this.dataForm.IsDelete = 0;
          }
          let params = Object.assign({}, this.dataForm);
          params.CreateTime = params.CreateTime / 1000;
          api
            .SaveUser(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //初始化复选框
    getCheck() {
      let that = this;
      if (that.dataForm.RoleType) {
        let roleTypeArry = that.dataForm.RoleType.split(",");
        roleTypeArry.forEach((item) => {
          switch (item) {
            case "1":
              that.checkedwillingness.push("受赠者");
              break;
            case "2":
              that.checkedwillingness.push("捐赠者");
              break;
            case "3":
              that.checkedwillingness.push("捐献者");
              break;
            case "4":
              that.checkedwillingness.push("救护者");
              break;
          }
        });
      }
    },
    //复选框选中事件
    handleChecked(roleTypeArry) {
      let that = this;
      let roleType = "";
      roleTypeArry.forEach((item) => {
        for (var i in that.willingness) {
          if (that.willingness[i].label == item) {
            if (roleType == "") {
              roleType = that.willingness[i].value;
            } else {
              roleType = roleType + "," + that.willingness[i].value;
            }
          }
        }
      });
      that.dataForm.RoleType = roleType;
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload-list__item-delete {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}

.hideButton .el-button--primary {
  display: none;
}
</style>
